/**
 * Remove File-Upload Button and check checkbox for most recent uploaded file
 */

const $ = window.jQuery;

export default {
  attach: function(context, settings) {
    let $newContent = $(context);

    // Hide UploadButton
    let $uploadButton = $newContent.find('button.js-hide.js-form-submit');
    $uploadButton.hide();

    // Check Checkbox for new uploaded files once
    let $fileIcon = $newContent.find(".js-form-managed-file .form-checkbox");
    $fileIcon.last().attr('checked', 'checked');
  }
}
